var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import LanguageSwitch from '@/components/language-switch/LanguageSwitch';
import { identifyApplication, identifyHostname } from '@/support/Client';
import axios from 'axios';
import ErrorHandler from '@/support/ErrorHandler';
import { RouteNameEnum } from '@/router/RouteName';
import { Auth } from '@/support/Auth';
let ResetPassword = class ResetPassword extends Vue {
    constructor() {
        super(...arguments);
        this.oAuthServer = identifyHostname() || '';
        this.oAuthClientId = 1;
        this.oAuthSecret = 'secret';
        this.oAuthScope = '*';
        this.valid = true;
        this.password = '';
        this.password_confirmation = '';
        this.passwordRules = [(v) => !!v || this.getPasswordErrorMessage('auth.required')];
        this.passwordConfirmationRules = [
            (v) => !!v || this.getPasswordErrorMessage('auth.required'),
            (v) => this.isPasswordEqual(v),
        ];
        this.isSubmitted = false;
    }
    isPasswordEqual(password) {
        return password === this.password || this.getPasswordErrorMessage('auth.no_match');
    }
    getPasswordErrorMessage(key) {
        return this.$t(key);
    }
    submit() {
        if (!this.password || !this.getEmail() || !this.getToken()) {
            return;
        }
        const payload = {
            email: this.getEmail(),
            password: this.password,
            token: this.getToken(),
        };
        const headers = {};
        if (window.location.hostname !== 'localhost') {
            headers['X-Application'] = identifyApplication();
        }
        const client = axios.create({
            baseURL: this.oAuthServer,
            headers,
        });
        client
            .put('/v3/forgot-password', payload)
            .then((response) => {
            this.isSubmitted = true;
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    getToken() {
        return this.$route.query.token;
    }
    getEmail() {
        return this.$route.query.email;
    }
    login() {
        const payload = {
            username: this.getEmail(),
            password: this.password,
            grant_type: 'password',
            client_id: this.oAuthClientId,
            client_secret: this.oAuthSecret,
            scope: this.oAuthScope,
        };
        Auth.login(payload)
            .then(async (user) => {
            if (!user) {
                throw Error;
            }
            await Promise.all([
                this.$store.dispatch('setIsStoreInitialized', false),
                this.$store.dispatch('userAuthenticated', user),
            ]);
            this.$router.push({ name: RouteNameEnum.HOME });
        })
            .catch((error) => {
            ErrorHandler.alert('The provided information was incorrect.', 'Invalid Credentials');
        });
    }
};
ResetPassword = __decorate([
    Component({
        components: {
            LanguageSwitch,
        },
    })
], ResetPassword);
export default ResetPassword;
